import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "admin-lte/dist/css/adminlte.min.css";
import apiManager from "../../api/apiManager";
import API_ENDPOINTS from "../../api/apiEndpoints";
import { useSelectedDealership } from "../../hooks/useLocalStorage";
import { showErrorMessage } from "../../shared/Services/toasterService";
import {
  showLoader,
  hideLoader,
} from "../../shared/Services/Loader/loaderService";
import { useLocalization } from "../../context/LocalizationContext";

const DealerServicesDashboard = () => {
  const navigate = useNavigate();
  const { t: localization } = useLocalization();
  const [selectedDealershipId] = useSelectedDealership();
  const [dealershipCount, setDealershipCount] = useState(0);
  const [dealerServicesCount, setDealerServicesCount] = useState(0);
  const [serviceDeskUserCount, setServiceDeskUserCount] = useState(0);
  const [customersCount, setCustomersCount] = useState(0);
  const [repairOrdersCount, setRepairOrdersCount] = useState(0);
  const [repairOrdersInProgressCount, setRepairOrdersInProgressCount] =
    useState(0);

  useEffect(() => {
    DashboardDataCount();
  }, [selectedDealershipId]);

  const DashboardDataCount = async () => {
    try {
      showLoader();
      const payload = {};
      if (selectedDealershipId) {
        payload.id = selectedDealershipId;
      }
      const response = await apiManager.post(
        API_ENDPOINTS.DASHBOARD_GET,
        payload,
      );
      if (response.status == 200) {
        const data = response.data;
        setCustomersCount(data.customersCount || 0);
        setDealerServicesCount(data.dealerServicesCount || 0);
        setDealershipCount(data.dealershipCount || 0);
        setRepairOrdersCount(data.repairOrdersCount || 0);
        setRepairOrdersInProgressCount(data.repairOrdersInProgressCount || 0);
        setServiceDeskUserCount(data.tenantUserCount || 0);
      } else {
        showErrorMessage(localization("failed_fetch_dashboard_data"));
      }
    } catch (error) {
      showErrorMessage(error);
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="dashboard-content">
            <div className="dashboard-card start-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("new_service_orders")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/new-service-orders-icon.svg"
                  alt={localization("service_orders") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{repairOrdersCount}</h5>
                <p>{localization("created_today")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-sky-blue text-white"
                  onClick={() =>
                    navigate("/second-step", { state: { reset: true } })
                  }
                >
                  {localization("start_service")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card active-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("active_service_orders")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/service-order-icon.svg"
                  alt={localization("service_orders") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{repairOrdersInProgressCount}</h5>
                <p>{localization("in_progress")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-vibrant-green text-white"
                  onClick={() =>
                    navigate("/repair-orders", {
                      state: { statusFilter: "inprogress" },
                    })
                  }
                >
                  {localization("active_service")}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card manage-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("customers")}
                </h4>
              </div>
              <div className="icon">
                <img
                  src="assets/images/dashboard/card-icons/customers-icon.svg"
                  alt={localization("customers") + " Icon"}
                />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title">{customersCount}</h5>
                <p>{localization("customers")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn bg-vivid-red text-white"
                  onClick={() => navigate("/customer")}
                >
                  {localization("manage")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card start-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("shop_locations")}
                </h4>
              </div>
              <div className="icon">
                <img src="assets/images/dashboard/card-icons/dealership-locations-icon.svg" />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title" style={{ color: "#e1b600" }}>
                  {dealershipCount}
                </h5>
                <p>{localization("shops")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn"
                  style={{ backgroundColor: "#e1b600", color: "#fff" }}
                  onClick={() => navigate("/services/dealership/list")}
                >
                  {localization("manage")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card active-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("dealership_services")}
                </h4>
              </div>
              <div className="icon">
                <img src="assets/images/dashboard/card-icons/dealership-services-icon.svg" />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title" style={{ color: "#8b5cf6" }}>
                  {dealerServicesCount}
                </h5>
                <p>{localization("services")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn"
                  style={{ backgroundColor: "#8b5cf6", color: "#fff" }}
                  onClick={() => navigate("/dealer-services")}
                >
                  {localization("manage")}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
            <div className="dashboard-card manage-service bg-white">
              <div className="dashboard-card-header">
                <h4 className="dashboard-card-title">
                  {localization("servicedesk_users")}
                </h4>
              </div>
              <div className="icon">
                <img src="assets/images/dashboard/card-icons/service-desk-user-icon.svg" />
              </div>
              <div className="dashboard-card-body">
                <h5 className="middle-title" style={{ color: "#007bff" }}>
                  {serviceDeskUserCount}
                </h5>
                <p>{localization("users")}</p>
              </div>
              <div className="dashboard-card-footer">
                <button
                  className="btn card-btn"
                  style={{ backgroundColor: "#007bff", color: "#fff" }}
                  onClick={() => navigate("/servicedeskusers")}
                >
                  {localization("manage")}{" "}
                  <i className="fa-solid fa-circle-arrow-right ms-2"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DealerServicesDashboard;
